export default {
      id: "alert-icon-warning-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#alert-icon-warning",
      toString: function () {
        return this.url;
      }
    }